// extracted by mini-css-extract-plugin
export default {"recos":"H3-z","productCardOverride":"I3-z","rowHasBadge":"J3-z"};